import React, { useEffect, useRef } from "react";

const AutoFocusInput = (props) => {
  const innerRef = useRef();

  useEffect(() => {
    setTimeout(() => innerRef.current?.focus(), 1);
  }, []);

  return <input {...props} ref={innerRef} />;
};

export default AutoFocusInput;
